import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { INVESTOR_FEATURE_CODES_ACTION_TYPE } from 'store/system/actions';

const initialState = {};

const investorFeatureCodesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case INVESTOR_FEATURE_CODES_ACTION_TYPE.GET_CODES:
        return payload || initialState;

      case INVESTOR_FEATURE_CODES_ACTION_TYPE.CREATE_CODE:
      case INVESTOR_FEATURE_CODES_ACTION_TYPE.EDIT_CODE:
        draft[payload.id] = payload;
        break;

      case INVESTOR_FEATURE_CODES_ACTION_TYPE.DELETE_CODE:
        delete draft[meta.id];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default investorFeatureCodesReducer;
